import classnames from 'classnames';
import type { ReactNode } from 'react';
import styled from 'styled-components';

import { Block } from '#src/atoms/layout/Block/index.tsx';
import { BodyM } from '#src/atoms/typography/index.tsx';

type Props = {
  children: ReactNode;
  selected: boolean;
  onClick: () => void;
  disabled?: boolean;
  big?: boolean;
};

const Button = styled(Block)`
  height: 30px;
  padding: 0px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--c-nd-800);
  &.big {
    height: 40px;
  }
  &.disabled {
    opacity: 0.5;
  }
  &.selected {
    border: 1px solid rgba(var(--c-rgb-blue-400), 0.25);
    background-color: rgba(var(--c-rgb-blue-400), 0.25);
  }
`;

export const TagButton = ({
  children,
  selected,
  onClick,
  disabled = false,
  big = false,
}: Props) => {
  return (
    <Button
      onClick={onClick}
      className={classnames({
        selected,
        big,
      })}
      noCollapse
      disabled={disabled}
    >
      <BodyM bold>{children}</BodyM>
    </Button>
  );
};
